module.exports = __webpack_public_path__ + "acd62e9c8f2f7f54870c1dcfc73cefb2.png";